<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Regras fiscais"
        p-read-link="fiscalRules.read.one"
        p-create-link="fiscalRules.create"
        p-name="fiscalRules"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwFiscalRulesRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'Descrição',
                value: 'descricao'
            }, {
                text: 'Ativo',
                value: 'ativo'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>